
        var result = require("!!../../../node_modules/css-loader/index.js!./framework-body.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/framework-body/framework-body.component.css
// module id = 1852
// module chunks = 1